import React, { useState } from 'react'
import { Button, Card, Drawer, Form, notification } from 'antd'
import { InputBox } from '../../../components/_utils/appUtils'
import { CyprusStatusUpdate } from '../actions/chooseStudent'
import { useDispatch } from 'react-redux'

const CyprusMoveToVisa = (props) => {
  let { visible, onClose, record, onSubmit } = props
  let [uploadedFile, setUploadedFile] = useState({})
  let dispatch = useDispatch()
  const events = {
    moveToVisaStage: async (record) => {
      let { _id: studentId, applications } = record
      if (applications.status != 'File Submitted') {
        return notification.error({
          message: 'Cannot move to Visa Approved before the file is submitted.'
        })
      }
      let obj = {
        studentId, applicationId: applications._id, status: 'Visa Approved'
      }
      if (!(uploadedFile && uploadedFile.name)) {
        notification.warning({
          message: 'Please choose a file'
        })
        return
      }

      let fd = new FormData()
      fd.append('obj', JSON.stringify(obj))
      if (uploadedFile && uploadedFile.name) {
        fd.append('visaApprovedDoc', uploadedFile)
      }

      let resp = await dispatch(CyprusStatusUpdate(fd))
      if (resp && resp.success) {
        setUploadedFile(undefined)
        onSubmit()
      }
    }
  }

  return (
    <Drawer
      visible={visible}
      title={`Move to Visa Approve`}
      width={600}
      closable={true}
      maskClosable={true}
      onClose={onClose}>
      <Card>
        <Form className={'vertical-form'} autoComplete='off'>
          <Form.Item>
            <InputBox title={'Choose File'}>
              <input
                type='file'
                onChange={(e) =>
                  e.target.files && e.target.files[0] && setUploadedFile(e.target.files[0])
                }
                className='form-control'
              />
            </InputBox>
          </Form.Item>
          <Form.Item style={{ marginTop: 25 }}>
            <Button type='primary' onClick={() => {
              events.moveToVisaStage(record)
            }}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Drawer>
  )
}

export default CyprusMoveToVisa
